import { Field, Formik, Form } from 'formik'
import React, { useState } from 'react'
import Card from '../Helpers/Card';
import { useApi } from '../../context/ApiProvider';
import { useLocale } from "../../localization/LocaleProvider";


function Help() {
    const [messageSentSuccess, setMessageSentSuccess] = useState(false);
    const [messageSentError, setMessageSentError] = useState(false);
    const Api = useApi();
    const { translate } = useLocale();

    function sendSupportTicket(values, setSubmitting, resetForm) {
        if(!values.text || values.text.length < 3) {
            alert("Please enter a message");
            setSubmitting(false);
            return;
        }

        Api.post("/supportForm", values).then(() => {
            setMessageSentSuccess("Your message has been sent");
            resetForm();
        }).catch((error) => {
            setMessageSentError("Something went wrong, please try again later");
            return Promise.reject();
        }).finally(() => {
            setSubmitting(false);
            setTimeout(() => {
                setMessageSentSuccess(false);
                setMessageSentError(false);
            }, 5000);
        });

    }

  return (
    <>
        <h2>{translate("Help")}</h2>
        <p>{translate("Here you can find help on how to use the Rolf-Administration system.")}</p>
        <div className='grid-container'>
            <section className='grow'>
                <h4>{translate("Contact support")}</h4>
                <Card>
                    <Formik
                        enableReinitialize={true}
                        initialValues={{text: ''}}

                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            sendSupportTicket(values, setSubmitting, resetForm);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                {messageSentSuccess && <div className="formControlSuccess">{messageSentSuccess}</div>}
                                {messageSentError && <div className="formControlError">{messageSentError}</div>}

                                <div className="formControl">
                                    <label htmlFor="text">{translate("Submit a question to support")}</label>
                                    <Field component="textarea" name="text" id="text" className="formControl" rows="4" />
                                </div>
                                <div className="formControl">
                                    <button type="submit" disabled={isSubmitting}>{translate("Send message")}</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <span>{translate("Or contact us by email")} <a href="mailto:support@rolf.se">support@rolf.se</a></span>
                </Card>

            </section>
            <section>
                <h4>{translate("Help documents")}</h4>
                <ul>
                    <li><a href="https://hr2mentor.sharepoint.com/:b:/s/Support/EcmpgbAPm1RAlAyIeEb9ynABKVJLHOEIHDqMx5Tk2bbAmA?e=FED1dR" target="_blank"><i className="fa fa-file-pdf-o" aria-hidden="true"></i> {translate("Instructions Rolf Administration (Pdf)")}</a></li>
                </ul>
            </section>
        </div>
    </>
  )
}

export default Help
